import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Footer from './../common/Footer';
import Slider from '@mui/material/Slider';
import NavigationMenu from '../NavigationMenu';
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { PolarArea } from 'react-chartjs-2';
ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

function WheelGuide(props) {
  const marks = [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
  ];

  const data = {
    labels: [
      'Physical Health',
      'Mental Health',
      'Family',
      'Social Relationship',
      'Fulfilment',
      'Environment',
      'Career & Business Aspirations',
      'Financial Status',
      'Decision Making',
      'Sustainability',
    ],
    datasets: [
      {
        label: ' Score ',
        data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
        backgroundColor: [
          //CategoryIndex>WheelItemIndex
          '#7d9cc1', //4 3>0
          '#b16d95', //6 5>1
          '#f5ca77', //10 9>2
          '#a9ddf4', //3 2>3
          '#f0a741', //5 4>4
          '#75a188', //9 8>5
          '#e26f8e', //7 6>6
          '#4080a0', //2 1>7
          '#ee8d72', //1 0>8
          '#9bc473', //8 7>9
        ],
        borderWidth: 3,
      },
    ],
  };
  const chartOptions = {
    plugins: {
      legend: {
        display: false,
        position: 'bottom',
        labels: {
          usePointStyle: false,
        },
      },
    },
    scales: {
      r: {
        grid: {
          display: true,
        },
        ticks: {
          display: true,
          color: 'rgba(0, 0, 0, 0)',
          backdropColor: 'rgba(0, 0, 0, 0)',
        },
      },
    },
    onClick: function (evt, element) {
      console.log(data.datasets[0].data[element[0].index]);
      console.log(data.labels[element[0].index]);
    },
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const valuetext = (value) => {
    return `${value}`;
  };
  return (
    <Box width="100%" display="flex" justifyContent="center">
      <NavigationMenu pageName={'Wheel Guide'} />
      <Box className="pageContainer2">
        <Box width="100%" className="bg-dashboard-image">
          <Box className="text-Section">
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '30px',
                fontFamily: 'Quicksand !important',
                paddingTop: '20px',
              }}
            >
              WHEEL GUIDE
            </Typography>
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '18px',
                paddingRight: '10px',
                fontFamily: 'Quicksand',
              }}
            >
              The DECAMA Wellbeing Wheel has ten 'elements' arranged as sectors
              of a Wheel. You can score each element between 1 and 10 according
              to how you feel about the element
            </Typography>
          </Box>

          <Box width="100%" paddingBottom="30px"></Box>
          <Box
            paddingBottom="30px"
            width="100%"
            display="flex"
            justifyContent="center"
          >
            <Box
              width="80%"
              display="flex"
              justifyContent="center"
              sx={{ maxWidth: '400px', maxHeight: '400px' }}
            >
              <PolarArea data={data} options={chartOptions} />
            </Box>
          </Box>
        </Box>
        <Box
          width="100%"
          sx={{
            paddingLeft: '20px',
            paddingRight: '20px',
            backgroundColor: '#4080A0',
          }}
        >
          <Box width="100%" sx={{ paddingTop: '30px' }}>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: '400',
                color: 'white',
                paddingBottom: '10px',
                fontFamily: 'Quicksand',
              }}
            >
              How to complete your DECAMA Wellbeing Wheel
            </Typography>
          </Box>
          <Box width="100%" className="white-Text">
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '28px',
                fontFamily: 'Quicksand',
              }}
            >
              STEP 1
            </Typography>
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '18px',
                paddingRight: '10px',
                paddingBottom: '10px',
                fontFamily: 'Quicksand',
              }}
            >
              Tap or click on COMPLETE YOUR WHEEL to start. The Wheel takes two
              or three minutes to complete.
              <br />
              You are taken to the first question - 'how do I feel about my
              physical health?'
              <br />
              If you feel your Physical Health is excellent, you could give a
              score of 8, 9 or 10.
              <br />
              If you feel your Physical Health is very poor, you could give a
              score of 1, 2 or 3.
              <br />
              <br />
              The question is about your perception of your own Physical Health
              at the moment; we recommend you give a quick response rather than
              think about the element in depth. Only you know how you feel about
              your Physical Health.
              <br />
              Slide the slider to give your score.
              <br />
              &nbsp;
            </Typography>
          </Box>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Slider
              sx={{ width: '90%' }}
              aria-label="Always visible"
              defaultValue={1}
              getAriaValueText={valuetext}
              valueLabelDisplay="auto"
              shiftStep={1}
              step={1}
              marks={marks}
              min={0}
              max={10}
              color="secondary"
            />
          </Box>
          <Box width="100%" className="white-Text" sx={{ marginTop: '10px' }}>
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '18px',
                paddingBottom: '10px',
                fontFamily: 'Quicksand',
              }}
            >
              Now complete the next nine questions about different aspects of
              your wellbeing.
              <br />
              Remember, the questions are about how you view your own
              circumstances. There are no 'right' or 'wrong' answers.
            </Typography>
          </Box>

          <Box width="100%" className="white-Text">
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '28px',
                paddingTop: '10px',
                fontFamily: 'Quicksand',
              }}
            >
              STEP 2
            </Typography>
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '18px',
                paddingRight: '10px',
                paddingBottom: '10px',
              }}
            >
              After completing all ten questions, you can tap or click 'VIEW MY
              SCORE'. You will see your DECAMA Wellbeing SCORE and a picture of
              a wheel. This is a visual representation of your wellbeing at the
              moment.
            </Typography>
          </Box>

          <Box width="100%" className="white-Text">
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '28px',
                paddingTop: '10px',
                fontFamily: 'Quicksand',
              }}
            >
              STEP 3
            </Typography>
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '18px',
                paddingRight: '10px',
                paddingBottom: '10px',
              }}
            >
              What does your DECAMA Wellbeing score mean?
              <br />
              You will see a short statement giving you an initial analysis of
              your DECAMA score. Scores range from a minimum of 10 to a maximum
              of 100.
            </Typography>
          </Box>

          <Box width="100%" className="white-Text">
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '28px',
                paddingTop: '10px',
                fontFamily: 'Quicksand',
              }}
            >
              STEP 4
            </Typography>
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '18px',
                paddingRight: '10px',
                paddingBottom: '10px',
              }}
            >
              Take a minute to think about your score, the statement and YOUR
              Wellbeing Wheel. What does your Wheel and the score make you think
              about? Are there any surprises? Are there areas where you could
              make changes?
            </Typography>
          </Box>

          <Box width="100%" className="white-Text">
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '28px',
                fontFamily: 'Quicksand',
              }}
            >
              STEP 5
            </Typography>
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '18px',
                paddingRight: '10px',
                fontFamily: 'Quicksand',
              }}
            >
              Tap or click on ARRANGE A 1:1 CALL if you would like a no-charge
              conversation with one of our qualified Consultants.
              <br />
              Or VISIT OUR WEBSITE for information and resources.
            </Typography>
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '18px',
                paddingTop: '10px',
                paddingBottom: '10px',
              }}
            >
              You can tap or click on 'ARRANGE A 1:1 CALL' for consultation or
              'VISIT OUR WEBSITE'
            </Typography>
          </Box>
        </Box>

        <Footer takethesurvey />
      </Box>
    </Box>
  );
}
export default WheelGuide;
